import { FormattedMessage } from 'react-intl';

type ResetSchedulerProps = {
  isScheduleModified: boolean;
  resetSchedule: () => Promise<void>;
};

const ResetScheduler = ({ isScheduleModified, resetSchedule }: ResetSchedulerProps) => {
  return (
    isScheduleModified && (
      <button
        type="button"
        className="btn btn-sm btn-link btn-text-icon me-2"
        onClick={resetSchedule}
        data-e2e="scheduler-reset-fixing"
      >
        <FormattedMessage id="accumulator.scheduler.reset" />
        <i className="icon">replay</i>
      </button>
    )
  );
};

export default ResetScheduler;
